import Component from '@glimmer/component';
import { getOwner } from '@ember/owner';

export default class TSToolTipComponent extends Component
{
	get isTesting() {
		// Check if we're in a testing environment
		const config = getOwner(this).resolveRegistration('config:environment');
		return config.environment === 'test';
	}
}
